module.exports = __webpack_public_path__ + "src/assets/img/guestlist_one_king2.eaeda36e.jpg";